import React, { Component } from 'react';
import './ContactInfoPage.css';
import * as regex from '../../../constants/regex';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import * as defaultState from '../../constants/DefaultState';
import * as formatData from '../../functions/formatData';
import { nextPage } from '../../functions/nextPage';
import { dropDownDefault } from '../../constants/webAppointmentConstants'


export class ContactInfoPage extends Component {
  emptyChoice = dropDownDefault;

  isValid() {
    let valid = (
      this.props.contact.relation &&
      this.props.contact.firstName &&
      this.props.contact.lastName &&
      this.props.contact.email &&
      this.props.contact.email.match(regex.EMAIL_REGEX) &&
      this.props.contact.phone &&
      this.props.contact.phone.match(regex.NUMERIC_PHONE_NUMBER_REGEX)
    );
    return !!valid;
  }

  render() {
    this.backNext = '';

    let title = this.props.patientSeenRecently ?
      'How would you like us to contact you about this appointment?' :
      'Let’s get started with your contact information.';

    let subtitle = this.props.patientSeenRecently ? 
      '' :
      'How would you like us to contact you about this appointment?';

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'select',
            id: 'relation',
            key: 'relation',
            label: 'Your relationship to the patient',
            onChange: (value) => {
              this.props.webAppointmentSetContactRelation(value === this.emptyChoice ? "" : value);
            },
            existingContent: this.props.contact.relation || undefined,
            required: true,
            requiredError: "Please select your relationship to the patient.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            options: [
              { name: this.emptyChoice, value: undefined },
              { name: 'Parent', value: 'Parent' },
              { name: 'Guardian', value: 'Guardian' },
              { name: 'Spouse', value: 'Spouse' },
              { name: 'Partner', value: 'Partner' },
              { name: 'Child', value: 'Child' },
              { name: 'Sibling', value: 'Sibling' },
              { name: 'Relative', value: 'Relative' },
              { name: 'Friend', value: 'Friend' },
              { name: 'Other', value: 'Other' }
            ]
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            {
              type: 'text',
              id: 'firstName',
              label: 'Your first name',
              onChange: (ev) => { this.props.webAppointmentSetContactFirstName(ev.target.value); },
              existingContent: this.props.contact.firstName || undefined,
              required: true,
              requiredError: "Please enter your first name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              maxLength: '140'
            },
          ],
          [
            {
              type: 'text',
              id: 'lastName',
              label: 'Your last name',
              onChange: (ev) => { this.props.webAppointmentSetContactLastName(ev.target.value); },
              existingContent: this.props.contact.lastName || undefined,
              required: true,
              requiredError: "Please enter your last name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              maxLength: '140'
            },
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            {
              type: 'text',
              id: 'email',
              label: 'Your email',
              onChange: (ev) => { 
                const formattedEmail = ev.target.value.replace(/\s/g, '');
                this.props.webAppointmentSetContactEmail(formattedEmail);
                return formattedEmail;
              },
              existingContent: this.props.contact.email,
              required: true,
              requiredError: "Please enter your email in this format: yourname@example.com",
              patternMatch: regex.EMAIL_REGEX,
              patternMatchError: "Please enter your email in this format: yourname@example.com",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              maxLength: '140'
            }
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            {
              type: 'text',
              id: 'phone',
              label: 'Your phone',
              onChange: (ev) => {
                let newValues = formatData.formatPhone(ev.target.value, ev.target.selectionStart);
                this.props.webAppointmentSetContactPhone(newValues.value);
                return newValues;
              },
              existingContent: this.props.contact.phone,
              required: true,
              requiredError: "Please enter your phone number with the area code.",
              patternMatch: regex.NUMERIC_PHONE_NUMBER_REGEX,
              patternMatchError: "Please enter your phone number with the area code.",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error"
            },
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage(null, { forMe: this.props.forMe, patientSeenRecently: this.props.patientSeenRecently }));
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem useDiv={true}>
            <header className='web-appt__header'>
              <h1>{title}</h1>
              {subtitle ? <p>{subtitle}</p> : null}
              <hr />
            </header>
          </GridItem>
        </Grid>

        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

ContactInfoPage.propTypes = {
  contact: defaultState.contactProptype,
  patientSeenRecently: PropTypes.bool.isRequired,
  webAppointmentSetContactRelation: PropTypes.func.isRequired,
  webAppointmentSetContactFirstName: PropTypes.func.isRequired,
  webAppointmentSetContactLastName: PropTypes.func.isRequired,
  webAppointmentSetContactEmail: PropTypes.func.isRequired,
  webAppointmentSetContactPhone: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    contact: state.webAppointmentForm.contact,
    patientSeenRecently: state.webAppointmentForm.patientSeenRecently
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetContactRelation: (value) => dispatch(webAppointmentActions.webAppointmentSetContactRelation(value)),
    webAppointmentSetContactFirstName: (value) => dispatch(webAppointmentActions.webAppointmentSetContactFirstName(value)),
    webAppointmentSetContactLastName: (value) => dispatch(webAppointmentActions.webAppointmentSetContactLastName(value)),
    webAppointmentSetContactEmail: (value) => dispatch(webAppointmentActions.webAppointmentSetContactEmail(value)),
    webAppointmentSetContactPhone: (value) => dispatch(webAppointmentActions.webAppointmentSetContactPhone(value)),
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(ContactInfoPage);
